import React, { Component, Fragment } from "react";
import Select from "react-select";
import { getMondaysChange, getMonthString } from "../../functions/index";
import "./index.css";

const months = [
  { value: 0, label: "Jan" },
  { value: 1, label: "Feb" },
  { value: 2, label: "Mar" },
  { value: 3, label: "Apr" },
  { value: 4, label: "May" },
  { value: 5, label: "Jun" },
  { value: 6, label: "Jul" },
  { value: 7, label: "Aug" },
  { value: 8, label: "Sep" },
  { value: 9, label: "Oct" },
  { value: 10, label: "Nov" },
  { value: 11, label: "Dec" },
];

const MonthStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    width: 100,
  }),
  option: (provided, _state) => ({
    ...provided,
    fontSize: 14,
  }),
};

const WeekStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    width: 250,
  }),
  option: (provided, _state) => ({
    ...provided,
    fontSize: 14,
  }),
};

class MonthWeekSelect extends Component {
  state = {
    weeks: [],
    month: {},
  };

  componentDidMount() {
    const current_month = new Date().getMonth();
    const allMondays = getMondaysChange(current_month);
    const weeks = allMondays.map((monday) => {
      return { value: monday, label: `From ${monday.toDateString()}` };
    });
    this.setState({
      weeks,
      month: { value: current_month, label: getMonthString(current_month) },
    });
  }

  componentDidUpdate(prevProps) {
    const { featuredContent, userType } = this.props;

    if (prevProps.userType !== userType) {
      const current_month = new Date().getMonth();
      const allMondays = getMondaysChange(current_month);

      let availableMondays;
      if (featuredContent) {
        availableMondays = this.getAvailableMondays(allMondays);
      } else availableMondays = allMondays;

      const weeks = availableMondays.map((monday) => {
        return { value: monday, label: `From ${monday.toDateString()}` };
      });
      this.setState({
        weeks,
        month: { value: current_month, label: getMonthString(current_month) },
      });
    }

    if (featuredContent) {
      const current_month = new Date().getMonth();
      const allMondays = getMondaysChange(current_month);
      let availableMondays;

      const { prospects: prevProspectsContent, members: prevMembersContent } =
        prevProps.featuredContent;
      const { prospects: prospectsContent, members: membersContent } =
        featuredContent;

      const shouldAvailableMondaysUpdate =
        prevProspectsContent.length !== prospectsContent.length ||
        prevMembersContent.length !== membersContent.length;

      if (shouldAvailableMondaysUpdate) {
        availableMondays = this.getAvailableMondays(allMondays);

        const weeks = availableMondays.map((monday) => {
          return { value: monday, label: `From ${monday.toDateString()}` };
        });
        this.setState({
          weeks,
          week: null,
          month: { value: current_month, label: getMonthString(current_month) },
        });
      }
    }
  }

  getAvailableMondays = (allMondays) => {
    const { userType, featuredContent } = this.props;

    let contentItems;
    switch (userType) {
      case "prospect":
        contentItems = featuredContent.prospects;
        break;
      case "member":
        contentItems = featuredContent.members;
        break;
      default:
        null;
    }
    return allMondays.filter((mondayTimestamp) => {
      return !contentItems.some((item) =>
        this.areDatesEqual(mondayTimestamp, item.starting_monday)
      );
    });
  };

  areDatesEqual = (UTCDate, timestampObj) => {
    const dateStringOne = new Date(UTCDate).toDateString();
    const dateStringTwo = new Date(timestampObj.seconds * 1000).toDateString();
    return dateStringOne === dateStringTwo;
  };

  handleSetMonth = (month) => {
    this.setState({ month });
    let mondays = getMondaysChange(month.value);
    const weeks = mondays.map((monday) => {
      return { value: monday, label: `From ${monday.toDateString()}` };
    });
    this.setState({ weeks });
  };

  handleSetWeek = (week) => {
    const { onSetWeek } = this.props;
    onSetWeek(week.value);
    this.setState({ week });
  };

  render() {
    const { weeks, month, week } = this.state;

    return (
      <div className="date-container">
        <Select
          value={month}
          onChange={this.handleSetMonth}
          options={months}
          styles={MonthStyles}
          placeholder="Month"
        />
        &nbsp;&nbsp;&nbsp;
        <Select
          value={week}
          onChange={this.handleSetWeek}
          options={weeks}
          styles={WeekStyles}
          placeholder="Select Week"
        />
      </div>
    );
  }
}

export default MonthWeekSelect;



// WEBPACK FOOTER //
// ./src/components/MonthWeekSelect/index.js